import { useEffect } from "react";
import Gutter from "ui-kit/Gutter";
import { SummaryCard } from "../SummaryCard";
import { Title } from "./Title";
import styles from "./ThankYouView.module.css";
import { MultiPetBanner } from "./MultiPetBanner";
import { AppBanner } from "./AppBanner";
import { LiabilityBanner } from "./LiabilityBanner";
import { useSignupDispatch } from "components/Signup/store/hooks";
import { updateMetadata } from "components/Signup/store/slices/metadata";
import {
  useAllValidAnimals,
  useCurrentAnimal,
} from "components/Signup/store/selectors/animals";
import { SpeciesEnum } from "../../../../../__generated__/globalTypes";
import { resumePreviewStore } from "components/Signup/flow/utils/previewStore";
import { useCustomer } from "components/Signup/store/selectors/customer";
import { getPackageConfig } from "components/ContentfulRenderer/ContentfulPackages/getPackageConfig";
import { getResparkProductNameFromSignupProduct } from "components/Signup/store/queries/input/utils";
import { ThankYouBanner } from "../tractive/ThankYouBanner";

export const ThankYouView = ({
  showLiabilityBanner,
  showMultipetBanner,
  showTractiveBanner,
}: {
  showLiabilityBanner?: boolean;
  showMultipetBanner?: boolean;
  showTractiveBanner?: boolean;
}) => {
  const { name, species } = useCurrentAnimal();

  const { email } = useCustomer();
  const dispatch = useSignupDispatch();
  const animals = useAllValidAnimals();

  useEffect(() => {
    dispatch(updateMetadata({ purchaseCompleted: true }));
  }, [dispatch]);

  resumePreviewStore.remove();

  function getShield() {
    const resparkProduct = getResparkProductNameFromSignupProduct({
      product: animals[0].insurances[0].product,
      species: animals[0].species,
    });

    const packageConfig = getPackageConfig({
      product: resparkProduct,
    })?.packages.find((pack) => pack.limit === animals[0].insurances[0].limit);

    return packageConfig?.img;
  }

  return (
    <div className={styles.container}>
      <Title
        name={name}
        imageUrl={
          animals.length > 1 ? "/images/shields/multipet.svg" : getShield()
        }
      />
      <Gutter size={2} />

      <SummaryCard withRibbon />

      {showTractiveBanner ? (
        <ThankYouBanner species={animals[0].species} />
      ) : null}
      {animals.length > 1 ? (
        <AppBanner email={email} species={species as SpeciesEnum} />
      ) : null}
      {showLiabilityBanner ? <LiabilityBanner /> : null}

      {showMultipetBanner ? <MultiPetBanner /> : null}

      {animals.length === 1 ? (
        <AppBanner email={email} species={species as SpeciesEnum} />
      ) : null}
    </div>
  );
};
